<template>
  <NavBar class="investment-transaction-navbar" hide-border>
    <template v-if="isBackButtonVisible" #left>
      <RoundedIcon
        tabindex="0"
        role="button"
        icon-name="ic_arrow_left"
        main-color="transparent"
        :text-color="NebraskaColors.elementPrimary"
        :hover-color="NebraskaColors.backgroundHover"
        aria-label="Voltar para página anterior"
        data-testid="navbar-back-button"
        has-hover
        @click="emitBackEvent"
        @keydown.space.enter="emitBackEvent"
      />
    </template>

    <template #center>
      <span>{{ title }}</span>
    </template>

    <template v-if="isCloseButtonVisible" #right>
      <RoundedIcon
        tabindex="0"
        role="button"
        icon-name="ic_cancel"
        main-color="transparent"
        :text-color="NebraskaColors.elementPrimary"
        :hover-color="NebraskaColors.backgroundHover"
        :aria-label="closeButtonAriaLabel"
        data-testid="navbar-close-button"
        has-hover
        @click="emitCloseEvent"
        @keydown.space.enter="emitCloseEvent"
      />
    </template>
  </NavBar>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { NavBar, RoundedIcon } from '@warrenbrasil/nebraska-web';

@Component({
  name: 'InvestmentTransactionNavbar',
  components: { NavBar, RoundedIcon }
})
export default class InvestmentTransactionNavbar extends Vue {
  @Prop({ type: String, default: 'Investir' })
  private title!: string;

  @Prop({ type: Boolean, default: false })
  private isBackButtonVisible!: boolean;

  @Prop({ type: Boolean, default: true })
  private isCloseButtonVisible!: boolean;

  @Prop({ type: String, required: true })
  private closeButtonAriaLabel!: string;

  private get NebraskaColors() {
    return NebraskaColors;
  }

  private emitBackEvent() {
    this.$emit('on-back');
  }

  private emitCloseEvent() {
    this.$emit('on-close');
  }
}
</script>

<style lang="less" scoped>
.investment-transaction-navbar {
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 10;
}
</style>
